export const KeywordRankEnum = {
  trend: {
    UP: 'UP',
    NO: 'NO',
    DOWN: 'DOWN',
  },
  trendOption: [
    {id: 'UP', text: '排名上升'},
    {id: 'NO', text: '排名稳定'},
    {id: 'DOWN', text: '排名下降'},
  ],
  countryOption: [
    {id: 'US', text: '美国-纽约', icon: 'iconmeiguo-'},
    {id: 'CA', text: '加拿大-渥太华', icon: 'iconjianada-'},
    {id: 'MX', text: '墨西哥', icon: 'iconmoxige'},
    {id: 'UK', text: '英国-伦敦', icon: 'iconyingguo-'},
    {id: 'DE', text: '德国-柏林', icon: 'icondeguo1'},
    {id: 'FR', text: '法国-巴黎', icon: 'iconfaguoqi'},
    {id: 'ES', text: '西班牙-马德里', icon: 'iconxiaoshou-'},
    {id: 'IT', text: '意大利-罗马', icon: 'iconyidali'},
    {id: 'JP', text: '日本-东京', icon: 'iconriben'},
    {id: 'AU', text: '澳大利亚', icon: 'iconaodaliya-'},
    {id: 'IN', text: '印度-新德里', icon: 'iconyindu'},
    {id: 'AE', text: '阿联酋-迪拜', icon: 'iconalabolianheqiuchangguo'},
    {id: 'SG', text: '新加坡', icon: 'iconicon_SGxinjiapo'},
    {id: 'NL', text: '荷兰-阿姆斯特丹', icon: 'iconhelan'},
    {id: 'SA', text: '沙特阿拉伯-利雅得', icon: 'iconshatealabo'},
    {id: 'BR', text: '巴西-巴西利亚', icon: 'iconbaxi'},
    {id: 'SE', text: '瑞典-斯德哥尔摩', icon: 'iconruidian'},
    {id: 'TR', text: '土耳其-安卡拉', icon: 'icontuerqi'},
  ]
};
